__turbopack_context__.v({
  "caption": "vKE3Eq_caption",
  "card": "vKE3Eq_card",
  "count": "vKE3Eq_count",
  "grid": "vKE3Eq_grid",
  "image": "vKE3Eq_image",
  "name": "vKE3Eq_name",
  "tile": "vKE3Eq_tile",
});
